import React from 'react';
import { TableCell } from '@unimed-fesp/components';

import ConteudoPorStatus from './ConteudoPorStatus';

const TableContent = ({
  idLista,
  headers,
  handleModalDetalheDocumento,
  beneficiario,
}) => {
  return (
    <>
      {headers.map((header) => {
        const actualDocument = beneficiario?.documentos.find(
          (documento) => documento.tipoDocumento === header.tipoDocumento
        );
        if (actualDocument) {
          return (
            <TableCell>
              <ConteudoPorStatus
                idLista={idLista}
                idArquivo={actualDocument.idArquivo}
                statusDocumento={actualDocument.status}
                handleModalDetalheDocumento={handleModalDetalheDocumento}
                beneficiario={beneficiario}
                tipoDocumento={actualDocument.tipoDocumento}
              />
            </TableCell>
          );
        }

        return <TableCell>-</TableCell>;
      })}
    </>
  );
};

export default TableContent;
